/* eslint-disable react/prop-types */

import React from 'react';
import { Col, Form } from 'react-bootstrap';
import { useController, useFormContext } from 'react-hook-form';

const ToggleWithDropdown = ({ metadata, control, errors }) => {
  const { id, label, options, defaultValue, isEditable, validation } = metadata;
  const toggleKeys = Object.keys(options); // Extract keys dynamically
  const initialToggleValue = defaultValue || toggleKeys[0]; // Default to the first key

  // Controller for the toggle
  const { field: toggleField } = useController({
    name: id, // Use the toggle's name as its key
    control,
    defaultValue: initialToggleValue // Default toggle value
  });

  const { field: dropdownField } = useController({
    name: toggleField.value,
    control,
    defaultValue: options[toggleField.value]?.defaultValue || ''
  });

  const visibleDropdown = options[toggleField.value];

  return (
    <Col>
      <Form.Group as={Col} sm={12} md={12} className="mb-3">
        {/* Toggle Switch */}
        <div className="d-flex justify-content-between align-items-center mb-2">
          <Form.Label className="mb-0">
            {label}
            {validation.required && <span className="text-danger ms-1">*</span>}
          </Form.Label>
          <Form.Check
            type="switch"
            id={`toggle-${id}`}
            disabled={!isEditable}
            checked={toggleField.value === toggleKeys[1]} // Toggle dynamically between keys
            onChange={e => {
              const newValue = e.target.checked ? toggleKeys[1] : toggleKeys[0];
              toggleField.onChange(newValue); // Update the toggle value
              dropdownField.onChange(''); // Reset dropdown when toggle changes
            }}
          />
        </div>

        {/* Dynamic Dropdown */}
        <Form.Select
          {...(dropdownField.name &&
            control.register &&
            control.register(toggleField.value, {
              required: visibleDropdown?.validation?.required || false // Validation for the active dropdown
            }))}
          value={dropdownField.value}
          disabled={!isEditable}
          onChange={e => dropdownField.onChange(e.target.value)}
          isInvalid={!!errors[toggleField.value]} // Display errors for the active dropdown
        >
          <option value="">{visibleDropdown?.placeholder}</option>
          {visibleDropdown?.options.map(option => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </Form.Select>
        {errors[toggleField.value] && (
          <Form.Control.Feedback type="invalid" style={{ display: 'block' }}>
            {errors[toggleField.value].message}
          </Form.Control.Feedback>
        )}
      </Form.Group>
    </Col>
  );
};

export default ToggleWithDropdown;
